import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
`

export const ContentWrapper = styled.div`
  padding: 0 16px 48px;
`

export const FormContainer = styled.div`
  width: 100%;
`

export const FormWrapper = styled.div`
  padding: 32px 24px;
`
export const BottomActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-bottom: 48px;

  & > * {
    min-width: 300px;
  }
`


export const Text = styled("p")`
  margin-top: 0px;
  margin-bottom: 57px;
`;